export default {"src":"/_next/static/image/public/images/ic_male.2341eecb6083fe1257cd59b533faa95e.svg","height":24,"width":25};